import { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'dibs-elements/exports/Link';
import { HeaderFooterServerVarsContext } from '../HeaderFooterServerVarsContext/HeaderFooterServerVarsContext';
// styles
import dibsCss from 'dibs-css';
import styles from './SearchBarTerm.scss';

export const SearchBarTerm = props => {
    const { href, term, handleRowClick, cursorHighlightId, id, termElements } = props;
    const { isSearchBarRedesignVariant } = useContext(HeaderFooterServerVarsContext);
    const searchBarTermClasses = classnames({
        [styles.hoverBackground]: isSearchBarRedesignVariant,
        [styles.item]: !isSearchBarRedesignVariant,
        [styles.active]: id === cursorHighlightId,
    });
    const linkClasses = isSearchBarRedesignVariant
        ? classnames(dibsCss.textBodyMediumNormal, dibsCss.wFull, dibsCss.block, styles.linkItem)
        : styles.link;

    return (
        <div className={searchBarTermClasses}>
            <Link
                dataTn="search-bar-term"
                className={linkClasses}
                href={href}
                onClick={e => {
                    e.preventDefault();
                    handleRowClick(term, href, e);
                }}
            >
                {termElements}
            </Link>
        </div>
    );
};

SearchBarTerm.propTypes = {
    term: PropTypes.string,
    termElements: PropTypes.any,
    href: PropTypes.string,
    handleRowClick: PropTypes.func,
    cursorHighlightId: PropTypes.string,
    id: PropTypes.string,
};
